import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Alert, Form, Image, Modal, InputGroup } from 'react-bootstrap';
import { FaUserCircle, FaSignOutAlt, FaEdit, FaSave, FaTimes, FaCamera, FaLock, FaEye, FaEyeSlash, FaPhone, FaEnvelope, FaGraduationCap, FaUniversity, FaBriefcase, FaMapMarkerAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  
  // Состояния для смены пароля
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [changingPassword, setChangingPassword] = useState(false);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = () => {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    const userData = JSON.parse(localStorage.getItem('adminUser') || '{}');
    
    console.log('Profile - токен есть:', !!token);
    console.log('Profile - данные:', userData);
    
    if (!token) {
      setError('Не авторизован');
      setLoading(false);
      return;
    }
    
    if (!userData.id) {
      setError('Данные пользователя не найдены');
      setLoading(false);
      return;
    }
    
    fetchFullUserData(token, userData.id);
  };

  const fetchFullUserData = async (token, userId) => {
    try {
      const response = await fetch('/api/auth/me', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const fullData = await response.json();
        console.log('Полные данные с сервера:', fullData);
        setUser(fullData);
        setFormData(fullData);
      } else {
        const userData = JSON.parse(localStorage.getItem('adminUser') || '{}');
        setUser(userData);
        setFormData(userData);
      }
    } catch (err) {
      console.error('Ошибка загрузки данных:', err);
      const userData = JSON.parse(localStorage.getItem('adminUser') || '{}');
      setUser(userData);
      setFormData(userData);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('token');
    localStorage.removeItem('adminUser');
    navigate('/');
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setFormData(user);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    
    try {
      const response = await fetch('/api/auth/update', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          fio: formData.fio,
          email: formData.email,
          phone: formData.phone,
          university: formData.university,
          direction: formData.direction,
          specialty: formData.specialty,
          gradYear: formData.graduation_year || formData.gradYear,
          profilePic: formData.profile_pic,
          position: formData.position,
          workplace: formData.workplace,
          location: formData.location,
          linkedin: formData.linkedin,
          facebook: formData.facebook
        })
      });
      
      if (response.ok) {
        const updatedUser = { ...user, ...formData };
        localStorage.setItem('adminUser', JSON.stringify(updatedUser));
        setUser(updatedUser);
        setIsEditing(false);
        alert('Данные успешно обновлены');
      } else {
        const error = await response.json();
        alert(error.error || 'Ошибка при обновлении');
      }
    } catch (err) {
      console.error('Ошибка сохранения:', err);
      alert('Ошибка соединения с сервером');
    } finally {
      setSaving(false);
    }
  };

  // Функция смены пароля
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError('Новый пароль и подтверждение не совпадают');
      return;
    }
    
    if (passwordData.newPassword.length < 6) {
      setPasswordError('Новый пароль должен содержать не менее 6 символов');
      return;
    }
    
    setChangingPassword(true);
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    
    try {
      const response = await fetch('/api/auth/change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          oldPassword: passwordData.oldPassword,
          newPassword: passwordData.newPassword
        })
      });
      
      if (response.ok) {
        setPasswordSuccess('Пароль успешно изменен!');
        setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
        setTimeout(() => {
          setShowPasswordModal(false);
          setPasswordSuccess('');
        }, 2000);
      } else {
        const error = await response.json();
        setPasswordError(error.message || error.error || 'Ошибка при смене пароля');
      }
    } catch (err) {
      console.error('Ошибка смены пароля:', err);
      setPasswordError('Ошибка соединения с сервером');
    } finally {
      setChangingPassword(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', marginTop: '60px' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <Container className="py-5" style={{ marginTop: '60px' }}>
        <Alert variant="danger">{error}</Alert>
        <Button variant="primary" onClick={() => navigate('/')}>На главную</Button>
      </Container>
    );
  }

  return (
    <Container className="py-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', marginTop: '60px' }}>
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
            <div style={{ backgroundColor: '#006186', height: '100px' }}></div>
            <Card.Body className="p-4" style={{ marginTop: '-60px' }}>
              <div className="text-center mb-4">
                <div className="position-relative d-inline-block">
                  {user.profile_pic ? (
                    <Image 
                      src={user.profile_pic} 
                      roundedCircle 
                      style={{ width: '100px', height: '100px', objectFit: 'cover', border: '4px solid white' }} 
                    />
                  ) : (
                    <FaUserCircle size={100} color="#ccc" style={{ backgroundColor: 'white', borderRadius: '50%' }} />
                  )}
                </div>
                
                {!isEditing ? (
                  <>
                    <h2 className="fw-bold mt-3 mb-1">{user.fio || 'Пользователь'}</h2>
                    <p className="text-muted mb-2">{user.email}</p>
                    <span className="badge px-3 py-2" style={{ backgroundColor: '#00618620', color: '#006186' }}>
                      {user.role === 'admin' ? 'Администратор' : 'Пользователь'}
                    </span>
                  </>
                ) : (
                  <div className="mt-3">
                    <Form.Control
                      type="text"
                      name="fio"
                      value={formData.fio || ''}
                      onChange={handleChange}
                      className="text-center mb-2"
                      placeholder="ФИО"
                    />
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email || ''}
                      onChange={handleChange}
                      className="text-center"
                      placeholder="Email"
                    />
                  </div>
                )}
              </div>

              <div className="border-top pt-4">
                <h5 className="fw-bold mb-3" style={{ color: '#006186' }}>
                  <FaUserCircle className="me-2" /> Личная информация
                </h5>
                <Row className="g-3">
                  <Col md={6}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">
                        <FaPhone className="me-1" size={12} /> Телефон
                      </label>
                      {!isEditing ? (
                        <p className="fw-semibold mb-0">{user.phone || 'Не указан'}</p>
                      ) : (
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone || ''}
                          onChange={handleChange}
                          placeholder="Телефон"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">
                        <FaEnvelope className="me-1" size={12} /> Email
                      </label>
                      <p className="fw-semibold mb-0">{user.email}</p>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="border-top pt-4 mt-3">
                <h5 className="fw-bold mb-3" style={{ color: '#006186' }}>
                  <FaUniversity className="me-2" /> Образование
                </h5>
                <Row className="g-3">
                  <Col md={12}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">Университет</label>
                      {!isEditing ? (
                        <p className="fw-semibold mb-0">{user.university || 'Не указан'}</p>
                      ) : (
                        <Form.Control
                          type="text"
                          name="university"
                          value={formData.university || ''}
                          onChange={handleChange}
                          placeholder="Университет"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">Направление</label>
                      {!isEditing ? (
                        <p className="fw-semibold mb-0">{user.direction || user.edu_direction || 'Не указано'}</p>
                      ) : (
                        <Form.Control
                          type="text"
                          name="direction"
                          value={formData.direction || formData.edu_direction || ''}
                          onChange={handleChange}
                          placeholder="Направление"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">Специальность</label>
                      {!isEditing ? (
                        <p className="fw-semibold mb-0">{user.specialty || user.edu_specialty || 'Не указано'}</p>
                      ) : (
                        <Form.Control
                          type="text"
                          name="specialty"
                          value={formData.specialty || formData.edu_specialty || ''}
                          onChange={handleChange}
                          placeholder="Специальность"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="p-3 bg-light rounded-3">
                      <label className="text-muted small text-uppercase fw-bold mb-1">Год выпуска</label>
                      {!isEditing ? (
                        <p className="fw-semibold mb-0">{user.graduation_year || user.edu_grad_year || 'Не указан'}</p>
                      ) : (
                        <Form.Control
                          type="text"
                          name="graduation_year"
                          value={formData.graduation_year || formData.edu_grad_year || ''}
                          onChange={handleChange}
                          placeholder="Год выпуска"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              {(user.position || user.workplace || user.location) && (
                <div className="border-top pt-4 mt-3">
                  <h5 className="fw-bold mb-3" style={{ color: '#006186' }}>
                    <FaBriefcase className="me-2" /> Профессиональная деятельность
                  </h5>
                  <Row className="g-3">
                    {user.position && (
                      <Col md={6}>
                        <div className="p-3 bg-light rounded-3">
                          <label className="text-muted small text-uppercase fw-bold mb-1">Должность</label>
                          <p className="fw-semibold mb-0">{user.position}</p>
                        </div>
                      </Col>
                    )}
                    {user.workplace && (
                      <Col md={6}>
                        <div className="p-3 bg-light rounded-3">
                          <label className="text-muted small text-uppercase fw-bold mb-1">Место работы</label>
                          <p className="fw-semibold mb-0">{user.workplace}</p>
                        </div>
                      </Col>
                    )}
                    {user.location && (
                      <Col md={6}>
                        <div className="p-3 bg-light rounded-3">
                          <label className="text-muted small text-uppercase fw-bold mb-1">
                            <FaMapMarkerAlt className="me-1" size={12} /> Локация
                          </label>
                          <p className="fw-semibold mb-0">{user.location}</p>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              )}

              <div className="mt-4 d-flex gap-2 justify-content-center flex-wrap">
                {!isEditing ? (
                  <>
                    <Button 
                      variant="primary"
                      onClick={handleEdit}
                      style={{ backgroundColor: '#006186', border: 'none' }}
                    >
                      <FaEdit className="me-2" /> Редактировать профиль
                    </Button>
                    <Button 
                      variant="outline-primary"
                      onClick={() => setShowPasswordModal(true)}
                    >
                      <FaLock className="me-2" /> Сменить пароль
                    </Button>
                    <Button 
                      variant="outline-danger"
                      onClick={handleLogout}
                    >
                      <FaSignOutAlt className="me-2" /> Выйти
                    </Button>
                  </>
                ) : (
                  <>
                    <Button 
                      variant="success"
                      onClick={handleSave}
                      disabled={saving}
                    >
                      <FaSave className="me-2" /> {saving ? 'Сохранение...' : 'Сохранить'}
                    </Button>
                    <Button 
                      variant="secondary"
                      onClick={handleCancel}
                    >
                      <FaTimes className="me-2" /> Отмена
                    </Button>
                  </>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Модальное окно смены пароля */}
      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold" style={{ color: '#006186' }}>
            <FaLock className="me-2" /> Смена пароля
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={handlePasswordChange}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted">Текущий пароль</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showOldPassword ? 'text' : 'password'}
                  value={passwordData.oldPassword}
                  onChange={(e) => setPasswordData({ ...passwordData, oldPassword: e.target.value })}
                  required
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setShowOldPassword(!showOldPassword)}
                >
                  {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted">Новый пароль</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showNewPassword ? 'text' : 'password'}
                  value={passwordData.newPassword}
                  onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
                  required
                  minLength="6"
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
              <Form.Text className="text-muted">Минимум 6 символов</Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted">Подтверждение нового пароля</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                  required
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
            </Form.Group>

            {passwordError && (
              <Alert variant="danger" className="py-2">{passwordError}</Alert>
            )}
            {passwordSuccess && (
              <Alert variant="success" className="py-2">{passwordSuccess}</Alert>
            )}

            <div className="d-flex gap-2 justify-content-end mt-3">
              <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
                Отмена
              </Button>
              <Button 
                type="submit" 
                style={{ backgroundColor: '#006186', border: 'none' }}
                disabled={changingPassword}
              >
                {changingPassword ? 'Сохранение...' : 'Сменить пароль'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Profile;